// Mock data for the Federal Opportunity Intelligence Platform
export const opportunitiesData = [
  {
    id: "OPP-001",
    title: "ServiceNow ITSM Modernization",
    agency: "HHS",
    vehicle: "GSA MAS",
    tech: "ServiceNow",
    score: 92,
    recommendation: "Bid",
    due: "2026-03-15",
    risk: "Low"
  },
  {
    id: "OPP-002",
    title: "Salesforce Case Management",
    agency: "NIH",
    vehicle: "CIO-SP3",
    tech: "Salesforce GovCloud",
    score: 85,
    recommendation: "Bid",
    due: "2026-03-12",
    risk: "Medium"
  },
  {
    id: "OPP-003",
    title: "AWS Contact Center Upgrade",
    agency: "CMS",
    vehicle: "CMS SPARC",
    tech: "AWS / Amazon Connect",
    score: 88,
    recommendation: "Bid",
    due: "2026-03-22",
    risk: "Low"
  },
  {
    id: "OPP-004",
    title: "Data Lake & AI Analytics",
    agency: "DHS",
    vehicle: "SAM.gov",
    tech: "Data & AI",
    score: 78,
    recommendation: "Partner",
    due: "2026-04-10",
    risk: "Medium"
  },
  {
    id: "OPP-005",
    title: "DevSecOps Toolchain",
    agency: "VA",
    vehicle: "8(a) STARS III",
    tech: "DevSecOps",
    score: 73,
    recommendation: "Bid",
    due: "2026-03-05",
    risk: "Low"
  },
  {
    id: "OPP-006",
    title: "Legacy Mainframe Modernization",
    agency: "DOL",
    vehicle: "GSA MAS",
    tech: "Legacy Modernization",
    score: 65,
    recommendation: "Partner",
    due: "2026-04-30",
    risk: "High"
  },
  {
    id: "OPP-007",
    title: "Helpdesk Support Services",
    agency: "HHS",
    vehicle: "SAM.gov",
    tech: "Support Services",
    score: 58,
    recommendation: "No-Bid",
    due: "2026-02-28",
    risk: "High"
  },
  {
    id: "OPP-008",
    title: "ServiceNow HRSD Rollout",
    agency: "NIH",
    vehicle: "GSA MAS",
    tech: "ServiceNow",
    score: 82,
    recommendation: "Bid",
    due: "2026-03-25",
    risk: "Low"
  },
  {
    id: "OPP-009",
    title: "Salesforce DevOps Copado",
    agency: "CMS",
    vehicle: "CIO-SP3",
    tech: "Salesforce GovCloud",
    score: 77,
    recommendation: "Bid",
    due: "2026-03-18",
    risk: "Medium"
  },
  {
    id: "OPP-010",
    title: "AI Fraud Detection",
    agency: "HHS",
    vehicle: "SAM.gov",
    tech: "Data & AI",
    score: 90,
    recommendation: "Bid",
    due: "2026-03-30",
    risk: "Low"
  },
  {
    id: "OPP-011",
    title: "Zero Trust Security Upgrade",
    agency: "DHS",
    vehicle: "GSA MAS",
    tech: "DevSecOps",
    score: 55,
    recommendation: "No-Bid",
    due: "2026-03-01",
    risk: "High"
  },
  {
    id: "OPP-012",
    title: "Cloud Migration Support",
    agency: "VA",
    vehicle: "CMS SPARC",
    tech: "AWS / Amazon Connect",
    score: 68,
    recommendation: "Bid",
    due: "2026-04-05",
    risk: "Medium"
  },
  {
    id: "OPP-013",
    title: "CMDB Implementation",
    agency: "HHS",
    vehicle: "GSA MAS",
    tech: "ServiceNow",
    score: 84,
    recommendation: "Bid",
    due: "2026-03-27",
    risk: "Low"
  },
  {
    id: "OPP-014",
    title: "Reporting & BI Modernization",
    agency: "DOL",
    vehicle: "SAM.gov",
    tech: "Data & AI",
    score: 72,
    recommendation: "Bid",
    due: "2026-04-15",
    risk: "Medium"
  },
  {
    id: "OPP-015",
    title: "Network Operations Center Support",
    agency: "VA",
    vehicle: "8(a) STARS III",
    tech: "Support Services",
    score: 49,
    recommendation: "No-Bid",
    due: "2026-02-20",
    risk: "High"
  }
];

// Helper functions for data processing
export const getScoreBand = (score) => {
  if (score >= 80) return "High Fit (80-100)";
  if (score >= 60) return "Medium Fit (60-79)";
  if (score >= 40) return "Low Fit (40-59)";
  return "Poor Fit (0-39)";
};

export const getScoreBandShort = (score) => {
  if (score >= 80) return "High";
  if (score >= 60) return "Medium";
  if (score >= 40) return "Low";
  return "Poor";
};

export const getDueDateBucket = (dueDate) => {
  const today = new Date("2026-02-15"); // Reference date for demo
  const due = new Date(dueDate);
  const diffDays = Math.ceil((due - today) / (1000 * 60 * 60 * 24));
  
  if (diffDays <= 7) return "Due in 7 days";
  if (diffDays <= 14) return "Due in 14 days";
  if (diffDays <= 30) return "Due in 30 days";
  return "30+ days";
};

export const vehicles = [
  "All Vehicles",
  "GSA MAS",
  "CIO-SP3",
  "CMS SPARC",
  "8(a) STARS III",
  "SAM.gov"
];

export const agencies = [
  "All Agencies",
  "HHS",
  "NIH",
  "CMS",
  "DOL",
  "VA",
  "DHS"
];

export const techAreas = [
  "All Technologies",
  "ServiceNow",
  "Salesforce GovCloud",
  "AWS / Amazon Connect",
  "Data & AI",
  "DevSecOps",
  "Legacy Modernization",
  "Support Services"
];

export const scoreBands = [
  "All Scores",
  "High Fit (80-100)",
  "Medium Fit (60-79)",
  "Low Fit (40-59)",
  "Poor Fit (0-39)"
];

export const recommendations = [
  "Bid",
  "No-Bid",
  "Partner"
];
